import { createStructuredSelector } from 'reselect'
import { connect } from 'react-redux'
import { createVisiiUrl } from '../selectors/visiiSelector'

const mapStateToProps = createStructuredSelector({
  visiiUrl: createVisiiUrl,
})

export type ConnectorProps = {
  visiiUrl: string
}
export default connect(mapStateToProps)
